import styled from "styled-components"
import { formatAmount } from "../../utils/date"
import { DashboardCards } from "../styled/CustomCard"
import DealerListItem from "./DealerListItem"

const TopDealer = styled.div`
  font-weight: bold;
  background-color: #eee;
  padding: 0.5rem;
  align-items: center;

  span {
    font-weight: normal;
    display: block;
    padding-left: 1.5em;
  }
`

const Labels = styled.div`
  font-size: small;
  color: #999;
  padding-bottom: 0.5rem;
`

const DealerList = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem;

  .row {
    border-bottom: 1px solid #eee;
    padding: 0.15rem 0;
  }
`

type SalesClaimMadeDealerWiseData = {
  dealerName: string
  salesClaimMadeCount: number
}

type Props = {
  TopSKUDealers: SalesClaimMadeDealerWiseData[]
}

const DealersCard = ({ TopSKUDealers }: Props) => {
  const topSkusDealers = TopSKUDealers ?? []

  return (
    <div className="container-fluid h-100">
      <DashboardCards>
        <div className="row border-bottom">
          <div className="col">
            <h6>Top Dealers</h6>
          </div>
        </div>
        <div className="row pt-2">
          <div className="col-md-12">
            <Labels>
              <div className="row">
                <div className="col">Dealer</div>
                <div className="col text-end">Sales Claims Made</div>
              </div>
            </Labels>
            <TopDealer>
              <div className="row">
                <div className="col-6">
                  1. {topSkusDealers[0]?.dealerName}
                </div>
                <div className="col-6 text-end">
                  {formatAmount(topSkusDealers[0]?.salesClaimMadeCount)}
                </div>
              </div>
            </TopDealer>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <DealerList>
              {topSkusDealers.slice(1).map(
                (salesClaims: SalesClaimMadeDealerWiseData, index: number) => (
                  <DealerListItem
                    dealerName={salesClaims?.dealerName}
                    claimsMade={salesClaims?.salesClaimMadeCount}
                    key={index}
                    rank={index + 2}
                  />
                )
              )}
            </DealerList>
          </div>
        </div>
      </DashboardCards>
    </div>
  )
}

export default DealersCard
